import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * ProtectedRoute - Protege rutas basado en roles de usuario
 * @param {ReactNode} children - Componente a renderizar si autorizado
 * @param {string[]} allowedRoles - Array de roles permitidos para esta ruta
 * @param {string} redirectTo - Ruta de redirección si no autorizado (default: /login)
 */
export const ProtectedRoute = ({ children, allowedRoles, redirectTo = '/login' }) => {
  const { user, loading } = useAuth();

  // Mostrar loading mientras se verifica autenticación
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-emerald-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-stone-600">Verificando acceso...</p>
        </div>
      </div>
    );
  }

  // Si no hay usuario, redirigir a login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Si hay roles permitidos y el usuario no tiene uno de ellos
  if (allowedRoles && allowedRoles.length > 0) {
    const hasPermission = allowedRoles.includes(user.role);
    
    if (!hasPermission) {
      // Redirigir al dashboard correspondiente del usuario
      const roleRedirects = {
        'master_admin': '/admin-dashboard',
        'admin': '/admin-dashboard',
        'compras': '/compras',
        'produccion': '/produccion',
        'proveedor': '/proveedor',
        'cliente_empresa': '/empresa',
        'cliente_comprador': '/cliente'
      };
      
      const userDashboard = roleRedirects[user.role] || '/menu';
      return <Navigate to={userDashboard} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
